import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'

export const changeSrid = createActionCreator(actions.CHANGE_SRID, 'srid')



// WEBPACK FOOTER //
// ./src/actionCreators/srid.js